function AlpineCarousel() {
  Alpine.data('carousel', ({ pages, isMobile = false }) => ({
    pages,
    currentPage: 1,
    dragStartX: 0,
    dragEndX: 0,
    isDragging: false,
    onDragListener: null,
    endDragListener: null,

    init() {
      this.onDragListener = this.onDrag.bind(this)
      this.endDragListener = this.endDrag.bind(this)
    },

    startDrag(/** @type {MouseEvent|TouchEvent} */ e) {
      e.preventDefault()

      this.dragStartX = this.dragEndX = this.getClientX(e)
      this.isDragging = true

      if (isMobile) {
        document.addEventListener('touchmove', this.onDragListener)
        document.addEventListener('touchend', this.endDragListener)
      } else {
        document.addEventListener('mousemove', this.onDragListener)
        document.addEventListener('mouseup', this.endDragListener)
      }
    },

    onDrag(/** @type {MouseEvent|TouchEvent} */ e) {
      if (this.isDragging) {
        e.preventDefault()

        this.dragEndX = this.getClientX(e)
      }
    },

    endDrag() {
      if (this.isDragging) {
        const dragDistance = this.dragEndX - this.dragStartX

        if (dragDistance > 100) {
          this.currentPage = Math.max(1, this.currentPage - 1)
        } else if (dragDistance < -100) {
          this.currentPage = Math.min(this.pages, this.currentPage + 1)
        }

        this.dragStartX = 0
        this.dragEndX = 0
        this.isDragging = false

        if (isMobile) {
          document.removeEventListener('touchmove', this.onDragListener)
          document.removeEventListener('touchend', this.endDragListener)
        } else {
          document.removeEventListener('mousemove', this.onDragListener)
          document.removeEventListener('mouseup', this.endDragListener)
        }
      }
    },

    getClientX(/** @type {MouseEvent|TouchEvent} */ e) {
      return 'touches' in e ? e.touches[0].clientX : e.clientX
    },

    calculateTransform() {
      const pageOffset = ((this.currentPage - 1) / this.pages) * -100
      const dragOffset = this.dragEndX - this.dragStartX

      return `calc(${pageOffset}% + ${dragOffset}px)`
    },

    main: isMobile
      ? {
          [':class']() {
            return {
              'cursor-grabbing': this.isDragging,
              'cursor-grab': !this.isDragging,
            }
          },
          ['@touchstart.passive'](/** @type {TouchEvent} */ e) {
            this.startDrag(e)
          },
        }
      : {
          [':class']() {
            return {
              'cursor-grabbing': this.isDragging,
              'cursor-grab': !this.isDragging,
            }
          },
          ['@mousedown'](/** @type {MouseEvent} */ e) {
            this.startDrag(e)
          },
        },

    container: {
      [':class']() {
        return {
          'transition-transform duration-300 ease-in-out': !this.isDragging,
          'transition-none': this.isDragging,
        }
      },
      [':style']() {
        return {
          width: `${this.pages * 100}%`,
          transform: `translateX(${this.calculateTransform()})`,
        }
      },
    },
  }))
}

if (typeof Alpine !== 'undefined') {
  AlpineCarousel()
} else {
  document.addEventListener('alpine:init', AlpineCarousel)
}
